<template>
  <div class="gseaHallmark">
    <a-row>
      <a-col :span="24">
        <a-spin :spinning="spinning" tip="Loading...">
          <vxe-toolbar>
            <template #buttons>
              <vxe-input
                v-model="filterName_detable"
                type="search"
                placeholder="Input a key word"
                @keyup="searchEvent_detable"
              ></vxe-input>
              <vxe-button @click="exportDataEvent"
                ><a-icon type="cloud-download" /> Download</vxe-button
              >
            </template>
            <!-- <template #tools>
              <vxe-button status="sucess" @click="sortT()"
                >Sort by Median score of perturbed cells</vxe-button
              >
              <vxe-button status="sucess" @click="sortP()"
                >Sort by P-value</vxe-button
              >
            </template> -->
          </vxe-toolbar>
          <vxe-table
            border
            show-overflow
            class="my-sort"
            row-id="id"
            size="small"
            ref="xTable"
            :data="tableData_detable"
            align="center"
            header-align="center"
            :column-config="{ isHover: true }"
            :row-config="{ isCurrent: true, isHover: true }"
            :sort-config="{
              showIcon: false,
              trigger: all,
              defaultSort: { field: 'medianT', order: 'asc' },
            }"
            @header-cell-click="headerCellClickEvent"
          >
            <!-- <vxe-column type="expand" width="40">
              <template #content="{ row }">
                <object
                  :data="'http://research.gzsys.org.cn/perturbdb/' + row.view"
                  width="100%"
                  height="500"
                ></object>
              </template>
            </vxe-column> -->
            <vxe-column
              field="gene"
              title="Gene name"
              type="html"
              :titlePrefix="{
                icon: 'vxe-icon-question-circle-fill',
                color: 'red',
                useHTML: true,
                message: 'Perturbed gene',
              }"
            >
              <template #default="{ row }">
                <a
                  @click="goDataset(row.datasetid, row.gene)"
                  style="color: blue; font-weight: bolder"
                >
                  {{ row.gene }}</a
                >
              </template>
            </vxe-column>
            <vxe-column
              field="datasetid"
              title="Dataset ID"
              type="html"
            ></vxe-column>
            <vxe-column
              field="medianC"
              title="Median score of NT cells"
              sortable
              width="20%"
            >
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column
              field="medianT"
              title="Median score of perturbed cells"
              sortable
              width="20%"
            >
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column field="p" title="P-value" type="html" sortable>
              <template #default="{ row }">
                {{ Number.parseFloat(row.p).toPrecision(4) }}
              </template>
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span>
              </template>
            </vxe-column>
            <vxe-column
              field="counts"
              title="Dataset counts"
              type="html"
              sortable
            >
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column field="vision" title="View" type="html">
              <template #default="{ row }">
                <div
                  v-if="row.vision == 'TRUE'"
                  @click="showPDF(row.gene, row.datasetid, 'VISION')"
                >
                  <a-button type="primary" size="small">PDF</a-button>
                </div>
                <div v-else>
                  <a-button type="primary" size="small" disabled>PDF</a-button>
                </div>
              </template>
            </vxe-column>
            <template #empty>
              <span style="color: grey"></span>
            </template>
          </vxe-table>

          <vxe-pager
            background
            size="small"
            :loading="loading_detable"
            :current-page="tablePage_detable.currentPage"
            :page-size="tablePage_detable.pageSize"
            :total="tablePage_detable.totalResult"
            :page-sizes="[20, 50]"
            :layouts="[
              'PrevPage',
              'JumpNumber',
              'NextPage',
              // 'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange_table"
          >
          </vxe-pager> </a-spin
      ></a-col>
    </a-row>
    <a-modal
      :visible="this.modal"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      style="margin-top: 300px"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div slot="title">Scoring based on {{ this.methods }} algorithm</div>
      <div slot="cancelText"><a-icon type="cloud-download" /> Download</div>
      <pdf ref="pdf" :src="this.url" />
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";
import pdf from "vue-pdf";

export default {
  props: ["value"],
  components: {
    pdf,
  },
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      // 弹窗
      modal: false,
      url: "",
      methods: "",
      //加载
      spinning: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
      // 排序参数
      sortbyT: true,
      sortbyP: false,
    };
  },
  created() {
    this.spinning = true;
    var text = this.value;
    var match = /\(([^)]+)\)/.exec(text);
    var pathway = match ? match[1].trim() : null;
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/searchPheno.php",
        {
          params: {
            // dataset: this.$route.query.datasetId,
            // gene: this.$route.query.gene,
            datatype: pathway,
          },
        }
      )
      .then((response) => {
        // console.log(response.data);
        const convertedArray = response.data
          .filter((item) => {
            return item.p <= 0.001;
          })
          .sort((a, b) => {
            // 按照 medianC 升序排序
            return a.medianT - b.medianT;
          });

        let geneCounts = {};
        convertedArray.forEach((item) => {
          let gene = item.gene;
          geneCounts[gene] = (geneCounts[gene] || 0) + 1;
        });

        let newData = convertedArray.map((item) => ({
          ...item,
          counts: geneCounts[item.gene],
        }));
        this.getdata_detable = newData;
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },
  watch: {
    value() {
      this.filterName_detable = "";
      this.spinning = true;
      var text = this.value;
      var match = /\(([^)]+)\)/.exec(text);
      var pathway = match ? match[1].trim() : null;
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/searchPheno.php",
          {
            params: {
              // dataset: this.$route.query.datasetId,
              // gene: this.$route.query.gene,
              datatype: pathway,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          const convertedArray = response.data
            .filter((item) => {
              return item.p <= 0.001;
            })
            .sort((a, b) => {
              // 按照 medianC 升序排序
              return a.medianT - b.medianT;
            });

          let geneCounts = {};
          convertedArray.forEach((item) => {
            let gene = item.gene;
            geneCounts[gene] = (geneCounts[gene] || 0) + 1;
          });

          let newData = convertedArray.map((item) => ({
            ...item,
            counts: geneCounts[item.gene],
          }));
          this.getdata_detable = newData;
          this.findList_detable(this.getdata_detable);
          this.spinning = false;
        });
      this.spinning = false;
    },
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          // this.filterName_detable = "";
          this.spinning = true;
          var text = this.value;
          var match = /\(([^)]+)\)/.exec(text);
          var pathway = match ? match[1].trim() : null;
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/searchPheno.php",
              {
                params: {
                  // dataset: this.$route.query.datasetId,
                  // gene: this.$route.query.gene,
                  datatype: pathway,
                },
              }
            )
            .then((response) => {
              // console.log(response.data);
              const convertedArray = response.data
                .filter((item) => {
                  return item.p <= 0.001;
                })
                .sort((a, b) => {
                  // 按照 medianC 升序排序
                  return a.medianT - b.medianT;
                });

              let geneCounts = {};
              convertedArray.forEach((item) => {
                let gene = item.gene;
                geneCounts[gene] = (geneCounts[gene] || 0) + 1;
              });

              let newData = convertedArray.map((item) => ({
                ...item,
                counts: geneCounts[item.gene],
              }));
              this.getdata_detable = newData;
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.spinning = false;
            });
          this.spinning = false;
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    // 基因跳转
    goDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    sortT() {
      if (this.sortbyT) {
        this.getdata_detable = this.getdata_detable.sort((a, b) => {
          // 按照 medianC 升序排序
          return a.medianT - b.medianT;
        });
      } else {
        this.getdata_detable = this.getdata_detable.sort((a, b) => {
          // 按照 medianC 升序排序
          return b.medianT - a.medianT;
        });
      }
      this.sortbyT = !this.sortbyT;
      this.tempdata_detable = this.getdata_detable;
      this.findList_detable(this.getdata_detable);
    },
    sortP() {
      if (!this.sortbyP) {
        this.getdata_detable = this.getdata_detable.sort((a, b) => {
          // 按照 medianC 升序排序
          return a.p - b.p;
        });
      } else {
        this.getdata_detable = this.getdata_detable.sort((a, b) => {
          // 按照 medianC 升序排序
          return b.p - a.p;
        });
      }
      this.sortbyP = !this.sortbyP;
      this.tempdata_detable = this.getdata_detable;
      this.findList_detable(this.getdata_detable);
    },
    showPDF(value1, value2, value3) {
      var text = this.value;
      var match = /\(([^)]+)\)/.exec(text);
      var pathway = match ? match[1].trim() : null;
      (this.modal = true),
        (this.methods = value3),
        (this.url =
          "http://research.gzsys.org.cn/perturbdb/data/publications/" +
          value2 +
          "/Hallmark/" +
          pathway +
          "/" +
          value3 +
          "/" +
          value1 +
          ".pdf");
    },
    changeData(value) {
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.value,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.value + "-" + this.filterName_detable + "_related",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.modal = false;
    },
    handleCancel() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = this.url;

      link.setAttribute(
        "download",
        this.methods + "_" + this.url.split("/").pop()
      );

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName != "" || filterName != " ") {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["gene", "rtype", "datasetid"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>

<style>
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
